import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  celebrate(event) {
    if (event) event.preventDefault()

    this.ensureConfetti()
      .then(() => {
        if (typeof window.confetti === "function") {
          // Create multiple bursts from different positions
          const burst = (originY, particleCount = 500, spread = 180) =>
            window.confetti({
              particleCount: particleCount,
              spread: spread,
              startVelocity: 60,
              ticks: 300,
              origin: { y: originY },
              scalar: 1.3,
              gravity: 1.2,
              drift: 0,
              decay: 0.94
            })

          // Main burst from center
          burst(0.5, 600, 200)

          // Side bursts
          setTimeout(() => {
            window.confetti({
              particleCount: 300,
              angle: 60,
              spread: 100,
              origin: { x: 0, y: 0.6 },
              startVelocity: 55,
              scalar: 1.2
            })
          }, 150)

          setTimeout(() => {
            window.confetti({
              particleCount: 300,
              angle: 120,
              spread: 100,
              origin: { x: 1, y: 0.6 },
              startVelocity: 55,
              scalar: 1.2
            })
          }, 150)

          // Top burst
          setTimeout(() => burst(0.3, 400, 160), 300)

          // Final burst
          setTimeout(() => burst(0.6, 350, 140), 450)
        }
      })
      .catch(() => {})
  }

  ensureConfetti() {
    if (typeof window.confetti === "function") return Promise.resolve()

    return new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = "https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.2/dist/confetti.browser.min.js"
      script.async = true
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }
}

